<template>
  <div class="preferences__page">
    <v-btn @click="$router.go(-1)" small depressed>
      <v-icon left>
        mdi-arrow-left
      </v-icon>
      SALE CHANNELS
    </v-btn>
    <v-row no-gutters>
      <v-col cols="12" v-if="isLoading">
        <SkeletonLoaders type="card-heading, list-item-three-line" />
      </v-col>
      <v-col cols="12" v-else>
        <Criteo v-if="routePath.includes('criteo')" />
        <GoogleAnalytic v-if="routePath.includes('google')" />
        <GoogleAdsTracking
          :data="{
            googleAdsConversionTrack: attributes.googleAdsConversionTrack,
            googleAdsConversionLabel: attributes.googleAdsConversionLabel,
          }"
          ref="google-ads-tracking"
          v-if="routePath.includes('ggads')"
        />
        <FacebookPixel
          @removePixel="removePixel"
          @addPixel="addPixel"
          :facebookPixel="facebookPixel"
          v-if="routePath.includes('facebook')"
        />
        <TiktokIdPixel
          @removeTikTokPixel="removeTikTokPixel"
          @addTikTokPixel="addTikTokPixel"
          :tiktok="tiktok"
          v-if="routePath.includes('tiktok')"
        />
        <AxonPixel
          @removeAxonPixel="removeAxonPixel"
          @addAxonPixel="addAxonPixel"
          :axonPixel="axonPixel"
          v-if="routePath.includes('axonads')"
        />
        <AdRollPixel
          @removeAdRollPixel="removeAdRollPixel"
          @addAdRollPixel="addAdRollPixel"
          :adrollPixel="adrollPixel"
          v-if="routePath.includes('adroll')"
        />
        <Pinterest v-if="routePath.includes('pinterest')" />
        <Bing v-if="routePath.includes('bing')" />
        <Klaviyo v-if="routePath.includes('klaviyo')" />
        <TrustPilot v-if="routePath.includes('trustPilot')" />
      </v-col>
      <v-col cols="12" class="text-end">
        <v-btn @click="submit" :disabled="checkEmptyId()" :loading="isLoadingAction" color="primary">Save</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { preferencesApi } from '@/apis/preferences';
import { maxLength } from 'vuelidate/lib/validators';
import AdRollPixel from './components/AdRollPixel';
import AxonPixel from './components/AxonPixel';
import Bing from './components/Bing';
import Criteo from './components/CriteoOneTag';
import FacebookPixel from './components/FacebookPixel';
import GoogleAdsTracking from './components/GoogleAdsTracking';
import GoogleAnalytic from './components/GoogleAnalytic';
import Klaviyo from './components/Klaviyo';
import Pinterest from './components/Pinterest';
import TiktokIdPixel from './components/TiktokIdPixel';
import TrustPilot from './components/TrustPilot';

export default {
  components: {
    Criteo,
    GoogleAnalytic,
    GoogleAdsTracking,
    FacebookPixel,
    TiktokIdPixel,
    AxonPixel,
    Pinterest,
    Bing,
    Klaviyo,
    TrustPilot,
    AdRollPixel,
  },
  validations: {
    attributes: {
      favIcon: {},
      homePageTitle: {
        maxLength: maxLength(70),
      },
      homePageDescription: {
        maxLength: maxLength(320),
      },
      googleAnalyticsIds: {},
      googleAdsConversionTrack: {},
      facebookPixel: {},
      criteo: {},
      klaviyoApiKey: {},
      addionalScriptHead: {},
      addionalScriptBody: {},
      passwordProtectedEnable: {},
      passwordProtected: {
        maxLength: maxLength(320),
      },
      personalizePreview: {},
      personalizePreviewOption: {},
      truePilotEmail: '',
    },
  },
  data() {
    const routePath = this.$route.path.toString();
    return {
      loadingData: false,
      routePath: routePath,
      attributes: {
        image: '',
        criteo: {
          id: '',
        },
      },
      klaviyoListAndSegment: [],
      klaviyoListAndSegmentSms: [],
      facebookPixel: [
        {
          id: '',
          token: '',
        },
      ],
      tiktok: [{ pixel_id: '' }],
      axonPixel: [{ pixel_id: '' }],
      adrollPixel: [{ adroll_adv_id: '', adroll_pix_id: '' }],
      mode: '',
      image: {
        src: '',
        position: 1,
      },
      isLoading: false,
      isLoadingAction: false,
    };
  },
  created() {
    this.loadPreferences();
  },
  methods: {
    checkEmptyId() {
      let check;
      this.facebookPixel.forEach(i => {
        if (i.id === '') {
          check = true;
        } else {
          check = false;
        }
      });
      return check;
    },
    removePixel(index) {
      this.facebookPixel.splice(index, 1);
    },
    addPixel() {
      this.facebookPixel.push({
        id: '',
        token: '',
      });
    },
    removeTikTokPixel(index) {
      this.tiktok.splice(index, 1);
    },
    addTikTokPixel() {
      this.tiktok.push({
        pixel_id: '',
      });
    },
    removeAxonPixel(index) {
      this.axonPixel.splice(index, 1);
    },
    addAxonPixel() {
      this.axonPixel.push({
        pixel_id: '',
      });
    },
    removeAdRollPixel(index) {
      this.adrollPixel.splice(index, 1);
    },
    addAdRollPixel() {
      this.adrollPixel.push({
        adroll_adv_id: '',
        adroll_pix_id: '',
      });
    },
    getImageUpLoad(images) {},
    async loadPreferences() {
      this.isLoading = true;
      try {
        this.loadingData = false;
        let data = await preferencesApi.get();
        this.attributes = data.data;
        this.loadingData = true;
        this.facebookPixel = this.attributes.facebookPixel || [];
        this.tiktok = this.attributes.tiktok || [];
        this.axonPixel = this.attributes.axonPixel || [];
        this.adrollPixel = this.attributes.adrollPixel || [];
        if (this.attributes.favIcon) {
          this.image.src = this.attributes.favIcon;
        }
        if (this.attributes.personalizePreviewOption) {
          this.mode = this.attributes.personalizePreviewOption;
        }
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
    async submit() {
      this.attributes.facebookPixel = this.facebookPixel.map(x => x);
      this.attributes.tiktok = this.tiktok.map(x => x);
      this.attributes.axonPixel = this.axonPixel.map(x => x);
      this.attributes.adrollPixel = this.adrollPixel.map(x => x);
      this.attributes.personalizePreviewOption = this.mode;
      let googleAdsTracking = this.$refs['google-ads-tracking'];
      if (googleAdsTracking) {
        let conversion = googleAdsTracking.conversion;
        this.attributes.googleAdsConversionTrack = conversion.map(c => c.googleAdsConversionTrack).join(',');
        this.attributes.googleAdsConversionLabel = conversion.map(c => c.googleAdsConversionLabel).join(',');
      }
      this.isLoadingAction = true;
      try {
        await preferencesApi.update(this.attributes);
        // await this.loadPreferences();
        this.isLoadingAction = false;
      } catch (error) {
        this.isLoadingAction = false;
      }
    },
  },
};
</script>
